import React from "react"

function CovidBanner() {
  return (
    <div id="covid-banner">
        <div>
          Due to COVID we are only booking phone and virtual sessions
        </div>
    </div>
  )
}

export default CovidBanner
